import { Unit } from "../../isq/isq.js";
import { Codecs, } from "../types.js";
import { isq } from "../../isq/index.js";
import { BaseCodec } from "./base-codec.js";
import { splitBezier } from "../../d3-mapp/curve/split-bezier.js";
export class AngleCodec extends BaseCodec {
    static FULL_CIRCLE = 2 * Math.PI;
    static DEFAULT_NO_ANGLE_VALUE = -999.0;
    static ANGLE_UNIT_RADIAN = "angle.metric.radian";
    static ANGLE_UNIT_DEGREE = "angle.metric.degree";
    static ANGLE_UNIT_TURN = "angle.metric.turn";
    static ANGLE_UNIT_GON = "angle.metric.gon";
    static get = (definition) => {
        return new AngleCodec(isq.getUnit(definition.unit), definition.normalizedOnly, definition.noAngleValue);
    };
    unit;
    normalizedOnly;
    noAngleValue;
    minValue;
    midValue;
    maxValue;
    range;
    constructor(unit, normalizedOnly, noAngleValue) {
        super();
        this.normalizedOnly = normalizedOnly !== false;
        this.noAngleValue =
            noAngleValue !== undefined
                ? noAngleValue
                : AngleCodec.DEFAULT_NO_ANGLE_VALUE;
        this.setUnit(unit);
    }
    setUnit(unit) {
        this.unit = unit;
        this.minValue = this.unit.fromBase(0);
        this.maxValue = this.unit.fromBase(2 * Math.PI);
        this.range = this.maxValue - this.minValue;
        this.midValue = this.range / 2.0;
        return this;
    }
    encodeSize() {
        return 2;
    }
    domain() {
        return [this.minValue, this.maxValue];
    }
    getDefinition() {
        return {
            id: Codecs.ANGLE,
            unit: this.unit.getName(),
            noAngleValue: this.noAngleValue,
            normalizedOnly: this.normalizedOnly,
        };
    }
    toString() {
        return JSON.stringify(this.getDefinition());
    }
    encode(decodedValue) {
        if (decodedValue != null) {
            const angle = decodedValue;
            const radians = this.unit.toBase(angle);
            // calculate X and Y (Cartesian coordinates)
            let xy;
            if (this.normalizedOnly &&
                (radians < 0.0 || radians > AngleCodec.FULL_CIRCLE)) {
                xy = [0.0, 0.0];
            }
            else {
                xy = [Math.cos(radians), Math.sin(radians)];
            }
            //console.debug(`angle enc.: value=${angle}, rad=${radians}, x=${xy[0]}, y=${xy[1]}`);
            return xy;
        }
        else {
            return [null, null];
        }
    }
    decode(encodedValue, index = 0) {
        return encodedValue[index] != null && encodedValue[index + 1] != null
            ? this._decodeAngle(encodedValue[index], encodedValue[index + 1])
            : null;
    }
    _decodeAngle(x, y) {
        let angle;
        let radians = Number.NaN;
        if (x === 0.0 && y === 0.0) {
            //angle = this.noAngleValue;
            return null;
        }
        else {
            radians = Math.atan2(y, x); // !! y first then x
            if (this.normalizedOnly) {
                while (radians < 0.0)
                    radians += AngleCodec.FULL_CIRCLE;
                while (radians > AngleCodec.FULL_CIRCLE)
                    radians -= AngleCodec.FULL_CIRCLE;
            }
            angle = this.unit.fromBase(radians);
        }
        //console.debug(`angle dec.: x=${x}, y=${y}, rad=${radians}, value=${angle}`);
        return angle;
    }
    interpolationPreprocessor(startAngle) {
        return (angle) => {
            const dAngle = angle - startAngle;
            return (angle +
                (Math.abs(dAngle) <= this.midValue
                    ? 0
                    : dAngle > 0
                        ? -this.maxValue
                        : this.maxValue));
        };
    }
    postProcessSpline(bc) {
        const result = this.splitSplineAtMinimum(bc).flatMap((splitBC) => this.splitSplineAtMaximum(splitBC));
        // if(result.length > 1){
        //   console.log(`postProcess Angle spline [${bc.cp[0].y} - ${bc.cp[3].y}] splitted in ${result.length} sections [${result.map(bc => `${bc.cp[0].y} - ${bc.cp[3].y}`).join(', ')}]`);
        // }
        return result;
        //return [bc];
    }
    splitSplineAtMinimum(bc) {
        const splittedSpline = splitBezier(bc, this.minValue);
        splittedSpline.forEach((sbc) => {
            if (sbc.cp.find((p) => p.y < this.minValue)) {
                sbc.cp.forEach((p) => (p.y += this.range));
            }
        });
        return splittedSpline;
    }
    splitSplineAtMaximum(bc) {
        const splittedSpline = splitBezier(bc, this.maxValue);
        splittedSpline.forEach((sbc) => {
            if (sbc.cp.find((p) => p.y > this.maxValue)) {
                sbc.cp.forEach((p) => (p.y -= this.range));
            }
        });
        return splittedSpline;
    }
}
